import { createReducer } from 'typesafe-actions';
import { tabImageAction, tabImageState } from './types';

import {
  SET_IS_OPEN,
  SET_IMAGE_DATA,
  SET_OPEN_ROW_NUM,
  SET_SELECT_PHOTO_DATA,
  SET_IS_DETAIL_VIEW_OPEN,
  GET_SEARCH_IMAGE,
  GET_SEARCH_IMAGE_ERROR,
  GET_SEARCH_IMAGE_SUCCESS,
  SET_ADD_IMAGE,
  SET_IMAGE_DATA_NULL,
} from './actions';

const initialState: tabImageState = {
  isOpenStatus: null,
  photosData: null,
  openRow: null,
  selectPhotoData: null,
  isDetailViewOpen: false,
  imageResult: null,
  addImageData: [],
  isLoadingImage: false,
};

const reducer = createReducer<tabImageState, tabImageAction>(initialState, {
  [SET_IS_OPEN]: (state, action) => ({
    ...state,
    isOpenStatus: action.payload,
  }),
  [SET_IMAGE_DATA]: (state, action) => ({
    ...state,
    photosData: action.payload,
  }),
  [SET_OPEN_ROW_NUM]: (state, action) => ({
    ...state,
    openRow: action.payload,
  }),
  [SET_SELECT_PHOTO_DATA]: (state, action) => ({
    ...state,
    selectPhotoData: action.payload,
  }),
  [SET_IS_DETAIL_VIEW_OPEN]: (state, action) => ({
    ...state,
    isDetailViewOpen: action.payload,
  }),

  [GET_SEARCH_IMAGE]: (state, action) => ({
    ...state,
    imageResult: null,
    isLoadingImage: true,
  }),
  [GET_SEARCH_IMAGE_SUCCESS]: (state, action) => ({
    ...state,
    imageResult: action.payload.payload,
    isLoadingImage: false,
  }),
  [GET_SEARCH_IMAGE_ERROR]: (state, action) => ({
    ...state,
    imageResult: null,
    isLoadingImage: false,
  }),

  [SET_IMAGE_DATA_NULL]: (state) => ({
    ...state,
    isLoadingImage: true,
    imageResult: null,
    addImageData: [],
  }),

  [SET_ADD_IMAGE]: (state, action) => ({
    ...state,
    addImageData: action.payload || [],
  }),
});

export default reducer;
